import React from 'react'

export const ResumeIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={'resume-icon-wrapper'}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.96301C6 4.30001 7.158 3.63501 8.595 4.47901L19.678 10.989C20.629 11.548 20.636 12.449 19.678 13.012L8.595 19.522Z"
                fill="currentColor"
            />
        </svg>
    )
}
